import { createFeatureSelector } from '@ngrx/store';
import { ANA_BIZ_APPLICATION_LIST_STORE_NAME, AnaBizApplicationListState } from './ana-biz-application-list.state';

/** Select AnaBizApplicationList State */
export const selectAnaBizApplicationListState = createFeatureSelector<AnaBizApplicationListState>(
  ANA_BIZ_APPLICATION_LIST_STORE_NAME
);
